<template>
  <div>
    <Table
      :no-data-text="$t('common.noData')"
      :columns="tableColumns"
      border
      :data="tableEC2Data"
      :span-method="handleSpan"
      :disabled-hover="true"
    ></Table>
  </div>
</template>

<script>
import { getCookie } from "../../../utils/cookieUtil.js";
let tableResourceOptimizationTag = {};
export default {
  name: "TableResourceOptimization",
  data() {
    return {
      companyId: "",
      accountIds: [],
      projectTag: "",
      riDataSource: "",
      company: getCookie(global.companyId),
      tableColumns: [
        {
          title: this.$t('Bill.ResourceOptimization.customer'),
          key: "companyName"
        },
        {
          title: this.$t('alarms.queue.region'),
          key: "region"
        },
        {
          title: this.$t('Bill.ResourceOptimization.os'),
          key: "os"
        },
        {
          title: this.$t('Bill.ResourceOptimization.instanceType'),
          key: "instanceType"
        },
        {
          title: this.$t('Bill.ResourceOptimization.EC2Count'),
          key: "instanceCount"
        },
        {
          title: this.$t('Bill.ResourceOptimization.RIRecommendedQuantity'),
          key: "longTimeInstanceCount"
        },
        {
          title: this.$t('Bill.ResourceOptimization.RIAvailableQuantity'),
          key: "reservedInstanceCount"
        },
        {
          title: this.$t('Bill.ResourceOptimization.purchaseRate'),
          key: "purchaseRate"
        },
        {
          title: this.$t('Bill.ResourceOptimization.exactlyMatchTheSavings'),
          key: "matchSaveCose",
          renderHeader: (h, params) => {
            return h("div", [
              h("span", this.$t('Bill.ResourceOptimization.exactlyMatchTheSavings')),
              h(
                "Tooltip",
                {
                  props: { placement: "top", transfer: true, maxWidth: "200" }
                },
                [
                  [
                    h(
                      "p",
                      { slot: "content" },
                      this.$t('Bill.ResourceOptimization.toolTips')
                    )
                  ],
                  [
                    h("Icon", {
                      props: { type: "md-help-circle" },
                      style: { color: "red", fontSize: "16px" }
                    })
                  ]
                ]
              )
            ]);
          }
        },
        {
          title: this.$t('Bill.ResourceOptimization.currentlyReservedToSaveCosts'),
          key: "riSaveCost",
          renderHeader: (h, params) => {
            return h("div", [
              h("span", this.$t('Bill.ResourceOptimization.currentlyReservedToSaveCosts')),
              h(
                "Tooltip",
                {
                  props: { placement: "top", transfer: true, maxWidth: "200" }
                },
                [
                  [
                    h(
                      "p",
                      { slot: "content" },
                      this.$t('Bill.ResourceOptimization.toolTips')
                    )
                  ],
                  [
                    h("Icon", {
                      props: { type: "md-help-circle" },
                      style: { color: "red", fontSize: "16px" }
                    })
                  ]
                ]
              )
            ]);
          }
        }
      ],
      tableEC2Data: []
    };
  },
  beforeCreate: function() {
    tableResourceOptimizationTag = this;
  },
  methods: {
    // 查询条件
    showEC2All: function(companyId, accountIds, projectTag, riDataSource) {
      tableResourceOptimizationTag.projectTag = projectTag;
      tableResourceOptimizationTag.companyId = companyId;
      tableResourceOptimizationTag.accountIds = accountIds;
      tableResourceOptimizationTag.riDataSource = riDataSource;
      tableResourceOptimizationTag.getData();
    },
    // 显示数据
    getData: function() {
      tableResourceOptimizationTag.$api.resourceOptimize
        .resourceOptimizationDashboard({
          companyId:
            this.companyId == null ||
            this.companyId == "" ||
            this.companyId == undefined
              ? this.company
              : this.companyId,
          projectTag: this.projectTag,
          accountIds: this.accountIds,
          riDataSource: this.riDataSource
        })
        .then(res => {
          this.assembleData(res.data);
        });
    },
    handleSpan({ row, column, rowIndex, columnIndex }) {
      // 客户列
      if (columnIndex == 0) {
        let x = row.companyNameNum == 0 ? 0 : row.companyNameNum;
        let y = row.companyNameNum == 0 ? 0 : 1;
        return [x, y];
      }
      // 区域列
      if (columnIndex == 1) {
        let x = row.regionNum == 0 ? 0 : row.regionNum;
        let y = row.regionNum == 0 ? 0 : 1;
        return [x, y];
      }
      // 操作系统列
      if (columnIndex == 2) {
        let x = row.osNum == 0 ? 0 : row.osNum;
        let y = row.osNum == 0 ? 0 : 1;
        return [x, y];
      }
    },
    assembleData(data) {
      // 数据处理算法，处理后，便于单元格的合并
      for (var i = 0; i < data.length; i++) {
        if (data[i].companyNameAlready !== 1) {
          if (data[i + 1]) {
            data[i].companyNameNum = 1;
            for (var j = i + 1; j < data.length; j++) {
              if (data[i].companyName === data[j].companyName) {
                data[i].companyNameNum++;
                data[j].companyNameNum = 0;
                data[j].companyNameAlready = 1;
              } else {
                break;
              }
            }
          }
        }
      }

      for (var k = 0; k < data.length; k++) {
        if (data[k].companyNameNum > 1) {
          for (var m = 0; m < data[k].companyNameNum; m++) {
            if (data[k + m].regionAlready !== 1) {
              if (m + 1 < data[k].companyNameNum) {
                data[k + m].regionNum = 1;
                for (var n = m + 1; n < data[k].companyNameNum; n++) {
                  if (data[k + m].region === data[k + n].region) {
                    data[k + m].regionNum++;
                    data[k + n].regionNum = 0;
                    data[k + n].regionAlready = 1;
                  } else {
                    break;
                  }
                }
              }
            }
          }
        }
      }

      for (var l = 0; l < data.length; l++) {
        if (data[l].regionNum > 1) {
          for (var p = 0; p < data[l].regionNum; p++) {
            if (data[l + p].osAlready !== 1) {
              if (p + 1 < data[l].regionNum) {
                data[l + p].osNum = 1;
                for (var z = p + 1; z < data[l].regionNum; z++) {
                  if (data[l + p].os === data[l + z].os) {
                    data[l + p].osNum++;
                    data[l + z].osNum = 0;
                    data[l + z].osAlready = 1;
                  } else {
                    break;
                  }
                }
              }
            }
          }
        }
      }
      this.tableEC2Data = data;
    }
  }
};
</script>
<style>
.green {
  background-color: #187 !important;
  color: #fff;
  font-weight: 600;
  border: none;
}
.red {
  background-color: #d22828 !important;
  color: #fff;
  font-weight: 600;
  border: none;
}
.yellow {
  background-color: yellow !important;
  border: none;
  color: #000;
  font-weight: 600;
}
</style>



// WEBPACK FOOTER //
// src/components/ebilling/resource_optimization/TableResourceOptimization.vue